var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockKey(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.998 62.5C54.3128 62.5 57.8105 59.0022 57.8105 54.6875C57.8105 50.3728 54.3128 46.875 49.998 46.875C45.6833 46.875 42.1855 50.3728 42.1855 54.6875C42.1855 59.0022 45.6833 62.5 49.998 62.5Z",
    stroke: "white",
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.998 62.5V71.875",
    stroke: "white",
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.248 34.375H18.748C17.0222 34.375 15.623 35.7741 15.623 37.5V81.25C15.623 82.9759 17.0222 84.375 18.748 84.375H81.248C82.9739 84.375 84.373 82.9759 84.373 81.25V37.5C84.373 35.7741 82.9739 34.375 81.248 34.375Z",
    stroke: "white",
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9355 34.375V20.3125C35.9355 16.5829 37.4171 13.006 40.0544 10.3688C42.6916 7.73158 46.2684 6.25 49.998 6.25C53.7277 6.25 57.3045 7.73158 59.9417 10.3688C62.579 13.006 64.0605 16.5829 64.0605 20.3125V34.375",
    stroke: "white",
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockKey);
export default __webpack_public_path__ + "static/media/LockKey.f6d3d1cad78d664706cf33421df7ca71.svg";
export { ForwardRef as ReactComponent };